<template>
  <div id="forgot-password-wg" class="container login-wg">
    <form class="login" @submit.prevent="resetPassword">
      <div class="row">
        <h1>
          <i class="fa fa-lock" aria-hidden="true"></i> Forgot your password ?
        </h1>
      </div>
      <div class="auth_indication_msg" :class="{ auth_error_msg: errored }">{{ message }}</div>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fas fa-user-tie"></i>
          </span>
        </div>
        <input
          type="email"
          class="form-control"
          placeholder="Enter your account email for a reset link"
          required
          v-model="email"
        />
      </div>
      <br />
      <button type="submit" class="form-control btn btn-danger btn-login">RESET MY PASSOWRD</button>
      <br />
      <br />
      <div>
        <span class="float-right font-weight-bold pr-2">
          <a href="/users/login">Sign In</a>
        </span>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errored: false,
      email: "",
      message: "",
    };
  },

  methods: {
    resetPassword: function () {
      this.$store
        .dispatch("resetPassword", this.email)
        .then(() => {
          this.errored = false;
          this.message = "";
          this.$toast.success(
            "Shortly, you will receive an email to reset your password...",
            {
              position: "top",
              onClose: () => this.$router.push("/portal"),
            }
          );
        })
        .catch((error) => {
          this.errored = true;
          this.message = error.response.data.fault.detail;
          /*setTimeout(function () {
            this.errored = false;
          }, 3000);*/
        });
    },
  },
};
</script>
